export interface Release {
    version: string
    content: Array<string>
}

export const RELEASES: Array<Release> = [
    {
        version: '2024.C',
        content: ['Feature: Upgrade to Angular v17']
    },
    {
        version: '2024.B',
        content: [
            'Feature: Perform a partial import for a specific user by removing all worklogs for that user in a period and importing them again as new worklogs',
            'Bug fix: Fix multi edit timecards'
        ]
    },
    {
        version: '2024.A',
        content: ['Feature: Specify the status (edited or new) for timecards when deapproving a timesheet']
    },
    {
        version: '2023.D',
        content: [
            'Feature: The upcoming year is added to the dropdown/datefilter when it is november or december',
            'Bug fix: Do not show archived projects in dropdown when creating a new timecard',
            'Bug fix: Improved responsiveness of the date filters'
        ]
    },
    {
        version: '2023.C',
        content: [
            'Feature: Add a visual clue in timecard dialog when dates are selected over multiple months',
            'Feature: Allow timecard description updates even after the timesheet has been approved (e.g. for updating tags)',
            'Feature: Change authentication system to use PeopleWare Google accounts instead of username and password',
            'Feature: Get realtime updates about starting and finishing import jobs',
            'Feature: Show timestamp and result of latest import run in navigation section',
            'Feature: Upgrade Angular from v9 to v15 (this might have a visual impact at some places, which we are still working on)',
            'Feature: Upgrade backend from .NET Framework 4.6 to .NET 6',
            'Bug fix: Editing a single timecard no longer creates a new instance',
            'Bug fix: Filtering on a person sometimes showed the full list of employees',
            'Bug fix: Fix page breaks on printing timesheets when selecting multiple timesheets'
        ]
    },
    {
        version: '2023.B',
        content: [
            'Bug fix: Introduction of # tags raised some unexpected tags',
            'Bug fix: Some timesheet nodes disappeared after viewing the timesheet'
        ]
    },
    {
        version: '2023.A',
        content: [
            'Feature: Add support for #tag/subtag next to the existing [[tag/subtag]].',
            "Feature: Create a new employee that doesn't necessarily has an Atlassian ID.",
            'Feature: Refresh employee filter autocomplete after changes to employees',
            'Feature: Shorten the duration of (error)messages',
            'Bug fix: Improved error handling in some cases',
            'Bug fix: Keep the employee names when editing time cards of multiple employees at the same time. The fields are now blanked out and optional when there are multiple timecards selected.',
            'Bug fix: Select multiple dates when creating time cards.',
            'Visual changes to the filters and authenticated user segment of the sidenav.',
            "Visual change to the what's new dialog."
        ]
    },
    {
        version: '2020.P',
        content: ['Removed all user_name references of employee, show atlassianAccountId instead']
    },
    {
        version: '2020.O',
        content: ['Show a detailed timecard instead of throwing an error when double clicking a locked timecard']
    },
    {
        version: '2020.N',
        content: ['Bug fix: Correctly saves the timecards with Date and not DateTime']
    },
    {
        version: '2020.M',
        content: ['Bug fix: Correctly fetches the timecards based on utc timezone']
    },
    {
        version: '2020.L',
        content: ["Added ASC sorting on the 'clients and projects' screen"]
    },
    {
        version: '2020.K',
        content: [
            'Added ASC sorting on timesheets and removed redundant information from the timesheet name where necessary'
        ]
    },
    {
        version: '2020.J',
        content: [
            'Disable timecard edit and delete button when a timecard is locked and added lock and edit timecard icons for clarity'
        ]
    },
    {
        version: '2020.I',
        content: ['Bug fix: Confidential stamp on timesheet-detail is now shown correctly']
    },
    {
        version: '2020.H',
        content: ['Added double click functionality to edit clients and projects']
    },
    {
        version: '2020.G',
        content: ['Bug fix: Edit projects dialog now shows the right checkbox information']
    },
    {
        version: '2020.F',
        content: [
            'Lowered the font size of all table icons and added colored icons to the groups inside timecard/timesheet tables'
        ]
    },
    {
        version: '2020.E',
        content: ['Show the last selected timesheet in the table when navigating back from the print timesheet screen.']
    },
    {
        version: '2020.D',
        content: ['Frontend reworked to Angular 9']
    },
    {
        version: '2020.C',
        content: ['Fix timesheets printing table cell height.']
    },
    {
        version: '2020.B',
        content: [
            'Use Atlassian ID instead of username on worklog import, update UI, quickfix for employees without name.'
        ]
    },
    {
        version: '2020.A',
        content: ['Modified printing settings.']
    },
    {
        version: '2019.L',
        content: ['Gray background for public holidays, just like weekends.']
    },
    {
        version: '2019.K',
        content: ["Bug fix: timesheet View after status Reset doesn't always work anymore."]
    },
    {
        version: '2019.J',
        content: [
            'Handle main-tag/sub-tag in timecards and timesheets.',
            'Handle multiple tags in timecards and timesheets.'
        ]
    },
    {
        version: 'JIRA-Sync',
        content: ['Tag-formatted label(s) of a Jira issue are automatically added to its worklog comments.']
    },
    {
        version: '2019.I',
        content: [
            'Modifications to fix printing problems.',
            'Cope with some unexplained behaviour of Jira when using [[ tags ]].'
        ]
    },
    {
        version: '2019.H',
        content: ['New PeopleWare logo + indication when test environment (which most of you will never see).']
    },
    {
        version: '2019.G',
        content: ['Allow choosing a new date when updating a group of timecards.']
    },
    {
        version: '2019.F',
        content: [
            'Full implementation of the [[ tags ]] concept + new timecards view and new timesheets view. Note: only 1 tag per timecard (or Jira worklog) is handled.'
        ]
    },
    {
        version: 'JIRA-Sync',
        content: ['Bug fix for Jira synchronization gaps in test environment DB (bug did not harm production DB).']
    },
    {
        version: '2019.E',
        content: ['Suppress [[ tags ]] in timesheet details, but not in timecard details.']
    },
    {
        version: '2019.D',
        content: [
            'Full-functional implementation of role RestrictedUser: view (almost) everything, but prohibit create/update/delete.',
            'Bug fix: Login with role RestrictedUser results in an immediate logout.',
            'Bug fix: Password boxes are not editable anymore in some cases.'
        ]
    },
    {
        version: '2019.C',
        content: ['Removed the 6 M restrictions when archiving projects and employees.']
    },
    {
        version: '2019.B',
        content: [
            'New flag "Show archived names" Y/N (= see button Profile).',
            'Archive older projects (if no underlying timecards exist for the last 6 M).',
            'Automatically archive project mapping criteria too, as to prevent new worklogs from being mapped onto an archived project.',
            'Archive former clients (if all underlying projects are archived).',
            'Archive former employees (if no underlying timecards exist for the last 6 M).',
            'Suppress the automatic filling-in of a (browser-saved) password in the profile dialog screen.',
            'Correction of erroneous sort order. (3x)'
        ]
    },
    {
        version: '2019.A',
        content: ['Correction of erroneous sort order. (3x)']
    },
    {
        version: 'JIRA-Sync',
        content: [
            'Changed to authentication-by-token for Jira sync.',
            'Variable Jira synch period: up till 14th/month also the whole previous month, after that only the current month.',
            'Jira synchronisation period increased to 45 days.'
        ]
    },
    {
        version: '2018.H',
        content: [
            'Calculate and show total days &amp; hours for a sub-selection of timesheets.',
            "Show version history information (= What's new)."
        ]
    },
    {
        version: '2018.G',
        content: [
            'Handle printing problems: prevent that print-preview is being invoked before timesheets are fully displayed.'
        ]
    },
    {
        version: '2018.F',
        content: ['Enhanced display of a warning when multiple timesheets of different clients are selected.']
    },
    {
        version: '2018.E',
        content: ['Display a warning when multiple timesheets of different clients are selected.']
    },
    {
        version: '2018.D',
        content: ['New timecard view: "by project > by month > by employee - by day".']
    },
    {
        version: '2018.C',
        content: [
            'Show the version number on the side navigation menu.',
            'Critical bug fix: Timecard grouping problems in case of non-unique project names.',
            'Critical bug fix: Timesheet grouping problems in case of non-unique project names.'
        ]
    },
    {
        version: 'older',
        content: ['Etc., etc., etc.']
    }
]
